module.exports = __webpack_public_path__ + "img/gzdp.97a33095.png";